import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-317a4dde"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "input"
};
const _hoisted_3 = ["placeholder"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, null, -1));
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  key: 1,
  class: "index-content"
};
const _hoisted_8 = {
  key: 0,
  class: "history"
};
const _hoisted_9 = {
  class: "history-title"
};
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 历史标签 ");
const _hoisted_11 = {
  class: "history-ul"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "transition"
}, null, -1));
const _hoisted_14 = {
  class: "swiper"
};
const _hoisted_15 = {
  class: "guess"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "name"
};
const _hoisted_18 = {
  key: 0,
  class: "card"
};
const _hoisted_19 = {
  class: "huo"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  class: "name"
};
const _hoisted_22 = {
  class: "project"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
  class: "img"
};
const _hoisted_25 = ["src"];
const _hoisted_26 = {
  class: "right"
};
const _hoisted_27 = {
  class: "name"
};
const _hoisted_28 = {
  class: "price-box"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, null, -1));
const _hoisted_30 = {
  class: "price"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon people"
}, null, -1));
const _hoisted_32 = {
  class: "people-num"
};
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" 查看更多排行榜 ");
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-nestmoreweibo"
}, null, -1));
const _hoisted_35 = [_hoisted_33, _hoisted_34];
const _hoisted_36 = {
  class: "product"
};
const _hoisted_37 = ["onClick"];
const _hoisted_38 = {
  class: "img"
};
const _hoisted_39 = ["src"];
const _hoisted_40 = {
  class: "right"
};
const _hoisted_41 = {
  class: "name"
};
const _hoisted_42 = {
  class: "price-box"
};
const _hoisted_43 = {
  class: "price"
};
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" 查看更多排行榜 ");
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-nestmoreweibo"
}, null, -1));
const _hoisted_46 = [_hoisted_44, _hoisted_45];
const _hoisted_47 = {
  class: "nav"
};
const _hoisted_48 = {
  class: "search_key"
};
const _hoisted_49 = {
  key: 0,
  class: "search_key_tips"
};
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" 已同时为您显示");
const _hoisted_51 = /*#__PURE__*/_createTextVNode("的搜索结果 ");
const _hoisted_52 = {
  key: 1,
  class: "banner"
};
const _hoisted_53 = ["src"];
const _hoisted_54 = {
  key: 2,
  class: "search-list"
};
const _hoisted_55 = ["onClick"];
const _hoisted_56 = {
  class: "img"
};
const _hoisted_57 = {
  key: 0,
  class: "type"
};
const _hoisted_58 = ["src"];
const _hoisted_59 = {
  class: "right"
};
const _hoisted_60 = ["innerHTML"];
const _hoisted_61 = {
  key: 0,
  class: "card-box"
};
const _hoisted_62 = ["innerHTML"];
const _hoisted_63 = {
  key: 1,
  class: "card-box"
};
const _hoisted_64 = {
  key: 1,
  class: "card-box-li card-box-li-official"
};
const _hoisted_65 = {
  key: 2,
  class: "card-box-li card-box-li-idea"
};
const _hoisted_66 = {
  key: 0,
  class: "card-box-li"
};
const _hoisted_67 = {
  key: 1,
  class: "card-box-li"
};
const _hoisted_68 = {
  key: 2,
  class: "card-box-li"
};
const _hoisted_69 = {
  key: 1,
  class: "card-box-li"
};
const _hoisted_70 = ["innerHTML"];
const _hoisted_71 = ["innerHTML"];
const _hoisted_72 = {
  class: "price-box"
};
const _hoisted_73 = {
  class: "backer_money"
};
const _hoisted_74 = {
  class: "backer_money"
};
const _hoisted_75 = {
  key: 1,
  class: ""
};
const _hoisted_76 = {
  key: 0
};
const _hoisted_77 = {
  key: 0,
  class: "hot"
};
const _hoisted_78 = ["onClick"];
const _hoisted_79 = {
  class: "cp-img"
};
const _hoisted_80 = ["src"];
const _hoisted_81 = ["innerHTML"];
const _hoisted_82 = {
  key: 3,
  class: "cp-box"
};
const _hoisted_83 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "5 稀有款", -1));
const _hoisted_84 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, null, -1));
const _hoisted_85 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, "共 20 款", -1));
const _hoisted_86 = [_hoisted_83, _hoisted_84, _hoisted_85];
const _hoisted_87 = {
  class: "sign"
};
const _hoisted_88 = ["onClick"];
const _hoisted_89 = {
  class: "shop-box"
};
const _hoisted_90 = {
  class: "merchant-header"
};
const _hoisted_91 = ["src"];
const _hoisted_92 = {
  class: "merchant-center"
};
const _hoisted_93 = ["innerHTML"];
const _hoisted_94 = {
  key: 0,
  class: "company_name"
};
const _hoisted_95 = {
  class: "merchant-num"
};
const _hoisted_96 = {
  key: 0
};
const _hoisted_97 = {
  key: 1
};
const _hoisted_98 = {
  key: 2
};
const _hoisted_99 = ["onClick"];
const _hoisted_100 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-plus"
}, null, -1));
const _hoisted_101 = /*#__PURE__*/_createTextVNode(" 关注 ");
const _hoisted_102 = [_hoisted_100, _hoisted_101];
const _hoisted_103 = ["onClick"];
const _hoisted_104 = {
  class: "product_info-img"
};
const _hoisted_105 = ["src"];
const _hoisted_106 = {
  class: "product_info-content"
};
const _hoisted_107 = {
  class: "product_info-name"
};
const _hoisted_108 = {
  class: "product_info-progress"
};
const _hoisted_109 = ["onClick"];
const _hoisted_110 = {
  class: "shop-header"
};
const _hoisted_111 = ["src"];
const _hoisted_112 = {
  class: "shop-center"
};
const _hoisted_113 = ["innerHTML"];
const _hoisted_114 = {
  class: "shop-btn"
};
const _hoisted_115 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-nestmoreweibo"
}, null, -1));
const _hoisted_116 = {
  key: 0,
  class: "shop-ul"
};
const _hoisted_117 = ["onClick"];
const _hoisted_118 = ["src"];
const _hoisted_119 = {
  class: "price"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_swipe_item = _resolveComponent("van-swipe-item");
  const _component_van_swipe = _resolveComponent("van-swipe");
  const _component_Error = _resolveComponent("Error");
  return _openBlock(), _createElementBlock("div", {
    class: "content",
    onScroll: _cache[15] || (_cache[15] = (...args) => $options.reloadScroll && $options.reloadScroll(...args))
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    onClick: _cache[0] || (_cache[0] = (...args) => $options.back && $options.back(...args)),
    src: "https://p6.moimg.net/md/jsheader/back.png",
    alt: ""
  }), _createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("input", {
    type: "text",
    ref: "keyinput",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.key = $event),
    onInput: _cache[2] || (_cache[2] = (...args) => $options.ketInput && $options.ketInput(...args)),
    placeholder: $data.guessText
  }, null, 40, _hoisted_3), [[_vModelText, $data.key]]), $data.key ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "icon",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.deleteInput && $options.deleteInput(...args))
  })) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: "search_bt",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.keyBtn && $options.keyBtn(...args))
  }, "搜索")]), $data.dorp && $data.dropdownList.length ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(['dorp', {
      ifApp: $options.ifApp
    }])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dropdownList, (item, idx) => {
    return _openBlock(), _createElementBlock("div", {
      class: "dorp-li",
      key: idx,
      onClick: $event => $options.dorpCli(item.suggestion)
    }, [_hoisted_5, _createElementVNode("div", {
      class: "text",
      innerHTML: item.suggestion
    }, null, 8, _hoisted_6)], 8, _hoisted_4);
  }), 128))], 2)) : _createCommentVNode("", true), !$data.searchShow ? (_openBlock(), _createElementBlock("div", _hoisted_7, [$data.historyList && $data.historyList.length ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", {
    class: "img",
    onClick: _cache[5] || (_cache[5] = $event => $data.historyList = [])
  })]), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.historyList, (item, idx) => {
    return _openBlock(), _createElementBlock("div", {
      class: "history-li",
      key: idx,
      onClick: $event => $options.historyClick(item)
    }, _toDisplayString(item), 9, _hoisted_12);
  }), 128))])])) : _createCommentVNode("", true), _hoisted_13, _createElementVNode("div", _hoisted_14, [_createVNode(_component_van_swipe, {
    onChange: $options.onChange,
    loop: false,
    width: $data.width
  }, {
    default: _withCtx(() => [_createVNode(_component_van_swipe_item, null, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: _normalizeClass({
          div: $data.swiperIndex !== 2
        })
      }, [_createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.guessList, (item, idx) => {
        return _openBlock(), _createElementBlock("div", {
          class: "guess-li",
          onClick: $event => $options.guessClick(item, idx + 1),
          key: idx
        }, [_createElementVNode("div", _hoisted_17, _toDisplayString(item.text), 1), item.show_tag_text ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(item.show_tag_text), 1)) : _createCommentVNode("", true)], 8, _hoisted_16);
      }), 128))]), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.huoList, (item, idx) => {
        return _openBlock(), _createElementBlock("div", {
          class: "huo-li",
          key: idx,
          onClick: $event => $options.hotClickFn(item)
        }, [_createElementVNode("div", {
          class: _normalizeClass(`card card${idx < 3 ? idx + 1 : 4}`)
        }, _toDisplayString(idx + 1), 3), _createElementVNode("div", _hoisted_21, _toDisplayString(item.text), 1), item.status && item.status.length ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(item.status, e => {
          return _openBlock(), _createElementBlock("div", {
            key: e,
            class: _normalizeClass(`status status${e}`)
          }, null, 2);
        }), 128)) : _createCommentVNode("", true), _createElementVNode("div", {
          class: _normalizeClass(`lift lift${item.lift}`)
        }, null, 2)], 8, _hoisted_20);
      }), 128))])], 2)]),
      _: 1
    }), _createVNode(_component_van_swipe_item, null, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: _normalizeClass({
          div: $data.swiperIndex !== 2
        })
      }, [_createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.projectList, (item, idx) => {
        return _openBlock(), _createElementBlock("div", {
          class: "project-li",
          onClick: $event => $options.jumpLiB(item, 'pro', idx + 1),
          key: idx
        }, [_createElementVNode("div", {
          class: _normalizeClass(`tag tag${idx}`)
        }, _toDisplayString(idx + 1), 3), _createElementVNode("div", _hoisted_24, [_createElementVNode("img", {
          src: _ctx.$imgUrlFilter(item.logo, 240),
          alt: ""
        }, null, 8, _hoisted_25)]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_28, [_hoisted_29, _createElementVNode("div", _hoisted_30, _toDisplayString(item.backer_money), 1), _hoisted_31, _createElementVNode("div", _hoisted_32, _toDisplayString(item.subscribe_count), 1)])])], 8, _hoisted_23);
      }), 128)), _createElementVNode("div", {
        class: "footer",
        onClick: _cache[6] || (_cache[6] = (...args) => $options.jumpRank && $options.jumpRank(...args))
      }, _hoisted_35)])], 2)]),
      _: 1
    }), _createVNode(_component_van_swipe_item, null, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: _normalizeClass({
          div: $data.swiperIndex !== 2
        })
      }, [_createElementVNode("div", _hoisted_36, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.productList, (item, idx) => {
        return _openBlock(), _createElementBlock("div", {
          class: "product-li",
          onClick: $event => $options.jumpLiB(item, 'mall_pro', idx + 1),
          key: idx
        }, [_createElementVNode("div", {
          class: _normalizeClass(`tag tag${idx}`)
        }, _toDisplayString(idx + 1), 3), _createElementVNode("div", _hoisted_38, [_createElementVNode("img", {
          src: _ctx.$imgUrlFilter(item.img_url, 240),
          alt: ""
        }, null, 8, _hoisted_39)]), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, "¥" + _toDisplayString(item.price), 1)])])], 8, _hoisted_37);
      }), 128)), _createElementVNode("div", {
        class: "footer",
        onClick: _cache[7] || (_cache[7] = (...args) => $options.jumpRank && $options.jumpRank(...args))
      }, _hoisted_46)])], 2)]),
      _: 1
    })]),
    _: 1
  }, 8, ["onChange", "width"])])])) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", {
    class: _normalizeClass(['nav-li', {
      hover: $data.search_type == 'all'
    }]),
    onClick: _cache[8] || (_cache[8] = $event => $options.toggleNavigation('all'))
  }, " 综合 ", 2), _createElementVNode("div", {
    class: _normalizeClass(['nav-li', {
      hover: $data.search_type == 'mall_pro'
    }]),
    onClick: _cache[9] || (_cache[9] = $event => $options.toggleNavigation('mall_pro'))
  }, " 商品 ", 2), _createElementVNode("div", {
    class: _normalizeClass(['nav-li', {
      hover: $data.search_type == 'pro'
    }]),
    onClick: _cache[10] || (_cache[10] = $event => $options.toggleNavigation('pro'))
  }, " 众筹 ", 2), _createElementVNode("div", {
    class: _normalizeClass(['nav-li', {
      hover: $data.search_type == 'idea'
    }]),
    onClick: _cache[11] || (_cache[11] = $event => $options.toggleNavigation('idea'))
  }, " 创意 ", 2), _createElementVNode("div", {
    class: _normalizeClass(['nav-li', {
      hover: $data.search_type == 'merchant'
    }]),
    onClick: _cache[12] || (_cache[12] = $event => $options.toggleNavigation('merchant'))
  }, " 商家 ", 2)]), _createElementVNode("div", _hoisted_48, [$data.correction_words && $data.correction_words.want_words ? (_openBlock(), _createElementBlock("div", _hoisted_49, [_hoisted_50, _createElementVNode("span", {
    class: "span",
    onClick: _cache[13] || (_cache[13] = $event => $options.tipClick($data.correction_words.want_words))
  }, "“" + _toDisplayString($data.correction_words.want_words) + "”", 1), _hoisted_51])) : _createCommentVNode("", true), $data.ads && $data.ads.length ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_createElementVNode("img", {
    onClick: _cache[14] || (_cache[14] = $event => $options.jumpSrc($data.ads[0].url)),
    src: _ctx.$imgUrlFilter($data.ads[0].show_url, 730),
    alt: ""
  }, null, 8, _hoisted_53)])) : _createCommentVNode("", true), $data.list && $data.list.length ? (_openBlock(), _createElementBlock("div", _hoisted_54, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, idx) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: idx
    }, [$data.typeMap.includes(item.type) ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(`li ${item.type}`),
      onClick: $event => $options.jumpLi(item, idx + 1)
    }, [_createElementVNode("div", _hoisted_56, [item.type === 'kuji' || item.type === 'luckycards' ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString($data.typeMapStr[item.type]), 1)) : _createCommentVNode("", true), _createElementVNode("img", {
      src: _ctx.$imgUrlFilter(item.card_info.img_url || item.card_info.logo, 360),
      alt: ""
    }, null, 8, _hoisted_58)]), _createElementVNode("div", _hoisted_59, [_createElementVNode("div", {
      class: "name",
      innerHTML: $options.text_replace(item.card_info.name, item.highlight)
    }, null, 8, _hoisted_60), item.type === 'kuji' ? (_openBlock(), _createElementBlock("div", _hoisted_61, [item.card_info.type == 1 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(`card-box-li card-box-li${item.card_info.type}`)
    }, " 预售 ", 2)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.card_info.marks, (e, i) => {
      return _openBlock(), _createElementBlock("div", {
        class: "card-box-li",
        key: i,
        innerHTML: $options.text_replace(e.name, item.highlight)
      }, null, 8, _hoisted_62);
    }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_63, [item.type === 'pro' ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(`card-box-li card-box-li${item.card_info.status_code}`)
    }, _toDisplayString(item.card_info.status), 3)) : _createCommentVNode("", true), item.card_info.official > 0 ? (_openBlock(), _createElementBlock("p", _hoisted_64, "自营")) : _createCommentVNode("", true), item.type === 'idea' ? (_openBlock(), _createElementBlock("p", _hoisted_65, "创意")) : _createCommentVNode("", true), item.type === 'mall_pro' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 3
    }, [item.card_info.spu_sale_status == 0 ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [item.card_info.presale_type > 0 ? (_openBlock(), _createElementBlock("p", _hoisted_66, "预售中")) : item.card_info.stock == 0 ? (_openBlock(), _createElementBlock("p", _hoisted_67, "补货中")) : (_openBlock(), _createElementBlock("p", _hoisted_68, "售卖中"))], 64)) : item.card_info.spu_sale_status == 1 ? (_openBlock(), _createElementBlock("p", _hoisted_69, "即将开售")) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 4
    }, [item.card_info.status_str ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(['card-box-li', {
        'card-box-li-status': item.card_info.status === 0
      }]),
      innerHTML: item.card_info.status_str
    }, null, 10, _hoisted_70)) : _createCommentVNode("", true)], 64)), item.card_info.category ? (_openBlock(), _createElementBlock("div", {
      key: 5,
      class: "card-box-li",
      innerHTML: item.card_info.category
    }, null, 8, _hoisted_71)) : _createCommentVNode("", true)])), _createElementVNode("div", _hoisted_72, [item.type === 'pro' || item.type === 'idea' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [item.card_info.status == '众筹中' && item.card_info.pro_class !== '102' && item.type !== 'idea' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createElementVNode("div", _hoisted_73, " 已筹 ¥" + _toDisplayString(item.card_info.backer_money), 1), _createElementVNode("div", _hoisted_74, " 进度 " + _toDisplayString(item.card_info.progress) + "% ", 1)], 64)) : item.card_info.subscribe_count ? (_openBlock(), _createElementBlock("div", _hoisted_75, _toDisplayString(item.card_info.subscribe_count) + "人看好 ", 1)) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createElementVNode("div", {
      class: _normalizeClass(`mall_price ${item.type}_price`)
    }, [_createTextVNode(" ¥" + _toDisplayString(item.card_info.price) + " ", 1), item.card_info.spu_sale_status == 1 && item.card_info.spu_start_sale_time ? (_openBlock(), _createElementBlock("span", _hoisted_76, _toDisplayString(item.card_info.spu_start_sale_time), 1)) : _createCommentVNode("", true)], 2), item.type === 'kuji' ? (_openBlock(), _createElementBlock("div", _hoisted_77, _toDisplayString(item.card_info.like_user_num) + " 人想要 ", 1)) : _createCommentVNode("", true)], 64))]), item.type === 'pro' || item.type === 'mall_pro' || item.type === 'luckycards' || item.type === 'idea' ? (_openBlock(), _createElementBlock("div", {
      key: 2,
      class: "cp-box",
      onClick: $event => $options.jumpCp(item.card_info.user_id || item.card_info.shop_id)
    }, [_createElementVNode("div", _hoisted_79, [_createElementVNode("img", {
      src: _ctx.$imgUrlFilter(item.card_info.user_icon || item.card_info.shop_logo, 48),
      alt: ""
    }, null, 8, _hoisted_80)]), _createElementVNode("div", {
      class: "cp-name",
      innerHTML: item.card_info.username || item.card_info.shop_name
    }, null, 8, _hoisted_81)], 8, _hoisted_78)) : item.type === 'kuji' ? (_openBlock(), _createElementBlock("div", _hoisted_82, _hoisted_86)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_87, _toDisplayString(item.ad_text), 1)], 10, _hoisted_55)) : item.type === 'merchant' ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "li shop",
      onClick: $event => $options.jumpLi(item, idx + 1)
    }, [_createElementVNode("div", _hoisted_89, [_createElementVNode("div", _hoisted_90, [_createElementVNode("img", {
      src: _ctx.$imgUrlFilter(item.card_info.user_icon, 176),
      alt: "",
      class: "merchant-img"
    }, null, 8, _hoisted_91), _createElementVNode("div", _hoisted_92, [_createElementVNode("div", {
      class: "merchant-name",
      innerHTML: $options.text_replace(item.card_info.nickname, item.highlight)
    }, null, 8, _hoisted_93), item.card_info.company_name ? (_openBlock(), _createElementBlock("div", _hoisted_94, "公司名称：" + _toDisplayString(item.card_info.company_name), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_95, [item.card_info.fan_num ? (_openBlock(), _createElementBlock("span", _hoisted_96, _toDisplayString(item.card_info.fan_num) + "粉丝", 1)) : _createCommentVNode("", true), item.card_info.pro_num ? (_openBlock(), _createElementBlock("span", _hoisted_97, _toDisplayString(item.card_info.pro_num) + "众筹", 1)) : _createCommentVNode("", true), item.card_info.idea_num ? (_openBlock(), _createElementBlock("span", _hoisted_98, _toDisplayString(item.card_info.idea_num) + "创意", 1)) : _createCommentVNode("", true)])]), !item.card_info.is_follow ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "merchant-btn",
      onClick: _withModifiers($event => $options.like(item, item.card_info.user_id), ["stop"])
    }, _hoisted_102, 8, _hoisted_99)) : _createCommentVNode("", true)]), item.card_info.product_info ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "product_info",
      onClick: _withModifiers($event => $options.jumpProject(item), ["stop"])
    }, [_createElementVNode("div", _hoisted_104, [_createElementVNode("img", {
      src: item.card_info.product_info.logo,
      alt: ""
    }, null, 8, _hoisted_105)]), _createElementVNode("div", _hoisted_106, [_createElementVNode("div", _hoisted_107, _toDisplayString(item.card_info.product_info.name), 1), _createElementVNode("div", _hoisted_108, [_createElementVNode("span", null, "已筹 ¥" + _toDisplayString(item.card_info.product_info.backer_money), 1), _createElementVNode("span", null, "进度 " + _toDisplayString(item.card_info.product_info.progress) + "%", 1)])])], 8, _hoisted_103)) : _createCommentVNode("", true), item.card_info.mall_shop_info ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "mall_shop_info",
      onClick: _withModifiers($event => $options.jumpShop(item), ["stop"])
    }, [_createElementVNode("div", _hoisted_110, [_createElementVNode("img", {
      src: _ctx.$imgUrlFilter(item.card_info.mall_shop_info.img, 176),
      alt: "",
      class: "shop-img"
    }, null, 8, _hoisted_111), _createElementVNode("div", _hoisted_112, [_createElementVNode("div", {
      class: "shop-name",
      innerHTML: $options.text_replace(item.card_info.mall_shop_info.name, item.highlight)
    }, null, 8, _hoisted_113)]), _createElementVNode("div", _hoisted_114, [_createTextVNode(_toDisplayString(item.card_info.mall_shop_info.product_num) + "件商品 ", 1), _hoisted_115])]), item.card_info.mall_shop_info.products ? (_openBlock(), _createElementBlock("div", _hoisted_116, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.card_info.mall_shop_info.products.slice(0, 4), (product, ix) => {
      return _openBlock(), _createElementBlock("div", {
        class: "shop-li",
        key: ix,
        onClick: _withModifiers($event => $options.toProduct(product.product_id, idx + 1), ["stop"])
      }, [_createElementVNode("img", {
        src: _ctx.$imgUrlFilter(product.img_url, 340),
        alt: ""
      }, null, 8, _hoisted_118), _createElementVNode("div", _hoisted_119, "¥" + _toDisplayString(product.price), 1)], 8, _hoisted_117);
    }), 128))])) : _createCommentVNode("", true)], 8, _hoisted_109)) : _createCommentVNode("", true)])], 8, _hoisted_88)) : _createCommentVNode("", true)], 64);
  }), 128))])) : (_openBlock(), _createBlock(_component_Error, {
    key: 3,
    message: "什么都没有搜到哦,换个词试试吧",
    img: "icon_nosearch"
  }))])], 64))], 32);
}